const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Medication/MedicationLayout.tsx';
import { CardContent, CardHeader } from '@mui/material';
import { css } from '@emotion/css';
import { useTheme } from '@mui/material/styles';
import { useMemo, ReactNode } from 'react';

interface IMedicationLayoutProps {
    header: ReactNode;
    content: ReactNode;
    appointmentList: ReactNode;
}

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            card: css`
                max-width: 100%;
                min-height: 100%;
                display: flex;
                // white is the only bg-color which works for the images (jpgs with white bg-color) we get from HCI
                background-color: ${theme.palette.common.white};
                border: 1px solid ${theme.palette.info.main};
                border-radius: 2px;
            `,
            cardHeader: css`
        padding-top:${theme.spacing(1)}
        align-items: normal;
        padding-bottom: 0.75em;
    `,
            cardContent: css`
                padding-bottom: ${theme.spacing(1)};
                display: flex;
                flex-direction: column;
                padding-top: 0;
            `,
            cardContentAL: css`
                display: flex;
                padding: 0;
                align-items: flex-start;
                ${theme?.breakpoints?.down?.('sm')} {
                    align-items: stretch;
                }
                gap: 10px;
            `,
            flexCol: css`
                flex: 1;
                display: flex;
                flex-direction: column;
            `,
        }),
        [theme]
    );
}

export const MedicationLayout = (props: IMedicationLayoutProps) => {
    const classes = useCSSClasses();
    return (
        <div className={classes.card}>
            <div className={classes.flexCol}>
                <CardContent className={classes.cardContent}>{props.content}</CardContent>
                <CardHeader title={props.header} className={classes.cardHeader} />
            </div>
            <div className={classes.cardContentAL}>{props.appointmentList}</div>
        </div>
    );
};
